/** Strings of the admin sync pages (`/sync`, `/sync/:id`, trigger buttons): `syncEn` is the source, `syncCs` must have the same keys. */
export const syncEn = {
  sync: {
    title: "Sync Status",
    jobsTotal: "{{count}} jobs total",
    filterPlaceholder: "Filter by type (e.g. gitlab_sync)…",
    empty: "No sync jobs found.",
    backfillSince: "backfill · since {{since}}",
    columns: {
      type: "Type",
      status: "Status",
      started: "Started",
      finished: "Finished",
      info: "Info",
    },
    status: {
      pending: "pending",
      running: "running",
      completed: "completed",
      failed: "failed",
    },
    completedWarnings_one: "completed · {{count}} warning",
    completedWarnings_few: "completed · {{count}} warnings",
    completedWarnings_many: "completed · {{count}} warnings",
    completedWarnings_other: "completed · {{count}} warnings",
    completedWarningsParen_one: "completed ({{count}} warning)",
    completedWarningsParen_few: "completed ({{count}} warnings)",
    completedWarningsParen_many: "completed ({{count}} warnings)",
    completedWarningsParen_other: "completed ({{count}} warnings)",
    projectsSkipped_one: "{{count}} project skipped",
    projectsSkipped_few: "{{count}} projects skipped",
    projectsSkipped_many: "{{count}} projects skipped",
    projectsSkipped_other: "{{count}} projects skipped",
    detail: "Detail",
    backToJobs: "← Back to sync jobs",
    created: "Created",
    duration: "Duration: {{seconds}} s",
    error: "Error",
    summary: "Summary",
    logs: "Logs ({{count}})",
    warnings: "Warnings ({{count}})",
    payload: "Payload",
    result: "Result",
    trigger: {
      gitlab_sync: "GitLab Sync",
      fakturoid_sync: "Fakturoid Sync",
      duplicate_scan: "Scan for duplicates",
      queued: "{{label}} queued",
      failed: "{{label}} failed",
      syncing: "Syncing",
      scanning: "Scanning",
    },
  },
};

export const syncCs: typeof syncEn = {
  sync: {
    title: "Stav synchronizace",
    jobsTotal: "Úloh celkem: {{count}}",
    filterPlaceholder: "Filtrovat podle typu (např. gitlab_sync)…",
    empty: "Žádné synchronizační úlohy nenalezeny.",
    backfillSince: "doplnění zpětně · od {{since}}",
    columns: {
      type: "Typ",
      status: "Stav",
      started: "Spuštěno",
      finished: "Dokončeno",
      info: "Info",
    },
    status: {
      pending: "čeká",
      running: "běží",
      completed: "dokončeno",
      failed: "selhalo",
    },
    completedWarnings_one: "dokončeno · {{count}} varování",
    completedWarnings_few: "dokončeno · {{count}} varování",
    completedWarnings_many: "dokončeno · {{count}} varování",
    completedWarnings_other: "dokončeno · {{count}} varování",
    completedWarningsParen_one: "dokončeno ({{count}} varování)",
    completedWarningsParen_few: "dokončeno ({{count}} varování)",
    completedWarningsParen_many: "dokončeno ({{count}} varování)",
    completedWarningsParen_other: "dokončeno ({{count}} varování)",
    projectsSkipped_one: "{{count}} projekt přeskočen",
    projectsSkipped_few: "{{count}} projekty přeskočeny",
    projectsSkipped_many: "{{count}} projektu přeskočeno",
    projectsSkipped_other: "{{count}} projektů přeskočeno",
    detail: "Detail",
    backToJobs: "← Zpět na synchronizační úlohy",
    created: "Vytvořeno",
    duration: "Doba trvání: {{seconds}} s",
    error: "Chyba",
    summary: "Souhrn",
    logs: "Logy ({{count}})",
    warnings: "Varování ({{count}})",
    payload: "Vstup",
    result: "Výsledek",
    trigger: {
      gitlab_sync: "Synchronizace GitLabu",
      fakturoid_sync: "Synchronizace Fakturoidu",
      duplicate_scan: "Najít duplicity",
      queued: "{{label}}: zařazeno do fronty",
      failed: "{{label}}: selhalo",
      syncing: "Synchronizuji",
      scanning: "Hledám",
    },
  },
};
